import React, { useState } from 'react';
import { useLayout } from '../../../../context/LayoutContext';
import { useTickets } from '../../../../context/TicketsContext';

const CreateTicketModal = () => {
  const { theme } = useLayout();
  const { 
    departments, 
    sections,
    createTicket, 
    setIsCreateModalOpen,
    currentDepartment
  } = useTickets();

  const [ticketData, setTicketData] = useState({
    title: '',
    description: '',
    priority: 'medium',
    category: 'technical',
    department: currentDepartment || 'logistica',
    status: 'reportados',
    reporter: 'Usuario Actual',
    assignee: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTicketData({
      ...ticketData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    createTicket(ticketData);
  };

  return (
    <div 
      className={`GM__${theme}-modal-overlay`}
      onClick={() => setIsCreateModalOpen(false)}
    >
      <div 
        className={`GM__${theme}-modal-content`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`GM__${theme}-modal-header`}>
          <h2>Crear Nuevo Ticket</h2>
          <button 
            className={`GM__${theme}-modal-close`}
            onClick={() => setIsCreateModalOpen(false)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className={`GM__${theme}-ticket-form`}>
          <div className={`GM__${theme}-form-group`}>
            <label htmlFor="title">Título *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={ticketData.title}
              onChange={handleChange}
              required
              className={`GM__${theme}-form-input`}
              placeholder="Describe brevemente el problema o solicitud"
            />
          </div>

          <div className={`GM__${theme}-form-group`}>
            <label htmlFor="description">Descripción *</label>
            <textarea
              id="description"
              name="description"
              value={ticketData.description}
              onChange={handleChange}
              required
              className={`GM__${theme}-form-textarea`}
              rows="4"
              placeholder="Proporciona detalles adicionales sobre el problema"
            />
          </div>

          <div className={`GM__${theme}-form-row`}>
            <div className={`GM__${theme}-form-group`}>
              <label htmlFor="department">Departamento</label>
              <select
                id="department"
                name="department"
                value={ticketData.department}
                onChange={handleChange}
                className={`GM__${theme}-form-select`}
              >
                {departments.map(dept => (
                  <option key={dept.id} value={dept.id}>{dept.name}</option>
                ))}
              </select>
            </div>

            <div className={`GM__${theme}-form-group`}>
              <label htmlFor="status">Estado</label>
              <select
                id="status"
                name="status"
                value={ticketData.status}
                onChange={handleChange}
                className={`GM__${theme}-form-select`}
              >
                {sections.map(section => (
                  <option key={section.id} value={section.id}>{section.name}</option>
                ))}
              </select>
            </div>
          </div>

          <div className={`GM__${theme}-form-row`}>
            <div className={`GM__${theme}-form-group`}>
              <label htmlFor="priority">Prioridad</label>
              <select
                id="priority"
                name="priority"
                value={ticketData.priority}
                onChange={handleChange}
                className={`GM__${theme}-form-select`}
              >
                <option value="low">Baja</option>
                <option value="medium">Media</option>
                <option value="high">Alta</option>
                <option value="critical">Crítica</option>
              </select>
            </div>

            <div className={`GM__${theme}-form-group`}>
              <label htmlFor="category">Categoría</label>
              <select
                id="category"
                name="category"
                value={ticketData.category}
                onChange={handleChange}
                className={`GM__${theme}-form-select`}
              >
                <option value="technical">Técnico</option>
                <option value="feature">Nueva funcionalidad</option>
                <option value="bug">Error</option>
                <option value="performance">Rendimiento</option>
                <option value="documentation">Documentación</option>
              </select>
            </div>
          </div>

          <div className={`GM__${theme}-form-group`}>
            <label htmlFor="assignee">Asignar a (opcional)</label>
            <input
              type="text"
              id="assignee"
              name="assignee"
              value={ticketData.assignee}
              onChange={handleChange}
              className={`GM__${theme}-form-input`}
              placeholder="Nombre del responsable"
            />
          </div>

          <div className={`GM__${theme}-form-actions`}>
            <button 
              type="button" 
              onClick={() => setIsCreateModalOpen(false)}
              className={`GM__${theme}-btn-secondary`}
            >
              Cancelar
            </button>
            <button type="submit" className={`GM__${theme}-btn-primary`}>
              Crear Ticket
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateTicketModal;